<main class="auth-content">
  <router-outlet />
</main>
